import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../EventBus";
import PointManager from "../PointManager/PointManager";
import AngleManager from "../AngleManager/AngleManager";
import SupplAngleManager from "../AngleManager/SupplAngleManager";
import LineManager from "../LineManager";
import CalculationLineManager from "../CalculationLineManager";
import { runCircleAnimation } from "./CircleAnimationSequence";
import Circle from "../../../../../../src/entities/Circle";
import CircleAnimationButton from "../../../../../../src/entities/UI/CircleAnimationButton/CircleAnimationButton";
import { Coord } from "../../../../../../src/types/Interface";
import { ContextType } from "../../types/Interface";
import { INFO_SLIDER_COORD } from "../../types/Config";


export default class CircleAnimationManager {
  private isSwitcherActive = false;
  
  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private SupplAngleManager: SupplAngleManager,
    private LineManager: LineManager,
    private CalcLineManager: CalculationLineManager,
    private circle: Circle,
    private cCoord: Coord,
  ) {
    this.drawAngles(this.PointManager.getRedPointsCoord(), false);
    this.addCircAnimBut()

    eventBus.on(EnumEventBus.supplementaryMode, v => this.isSwitcherActive = v);
  }
  getDelayForStartAnim = () => this.isSwitcherActive ? 4000 : 0;
  addCircAnimBut = () => new CircleAnimationButton(INFO_SLIDER_COORD, () => this.runAnimations(), () => this.getDelayForStartAnim());

  drawAngles = (rPointsCoord: Coord[], isbtw: boolean) => this.AngleManager.draw(rPointsCoord, isbtw);

  runAnimations() {
    eventBus.emit(EnumEventBus.setElementsForAnim, false);
    const context: ContextType = {
      circle: this.circle,
      AngleManager: this.AngleManager,
      PointManager: this.PointManager,
      LineManager: this.LineManager,
      SupplAngleManager: this.SupplAngleManager,
      CalcLineManager: this.CalcLineManager,
      cCoord: this.cCoord
    }

    runCircleAnimation(context, () => {
      rootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
      rootEventBus.emit(EnumRootEventBus.completedCircleAnim);
    });
  }
}
